import React from 'react'
import { getLiveApi } from './api'
import LiveLookupResponse, { Lookup } from '../common/types/api/LiveLookupResponse'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getLookups(): Promise<Lookup[]> {
    try {
        const liveLookupResponse = await getLiveApi<LiveLookupResponse>(`lookup?diffOnly=false&sort=title`)

        return liveLookupResponse.data
    } catch (error) {
        GlobalNotification.error(<Notification title={i18n('Error trying to get lookups: ')}>{error}</Notification>, 20)

        console.error(error)

        return []
    }
}

export function mockGetLookups(data: Lookup[]): () => Promise<Lookup[]> {
    return function (): Promise<Lookup[]> {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(data)
            }, 1000)
        })
    }
}
